export default class TabsHelper {
  static deactivateTab(tab, pane) {
    if (!tab || !pane) return false;

    tab.classList.remove('active');
    pane.classList.remove('active');

    return true;
  }
}
